export default "__VITE_ASSET__Do28_WB1__"